// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import ContentLink from '../components/ContentLink';

// img
import imgDownload from '../img/mult_download.png'
import img01 from '../img/page_1_img.png';

function Gaap01(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Sequencing</h2>
            <div className="content_text">
                The accuracy of sequencing data directly affects 
                the accuracy of assembly results, 
                analysis of gene structure and function, 
                and protein analysis. Sequence reads generated 
                by NGS platforms possess different characteristics 
                such as read length, type, and rate of errors.
            </div><br/>
            <div className="content_command_title">NGS platforms</div><br/>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={imgDownload} alt="error"/>
                </div>
                <div className="content_download_links">
                    <DownloadLinks name="Roche/454" link="https://sequencing.roche.com" />
                    <DownloadLinks name="illumina" link="http://www.ilumina.com" />
                    <DownloadLinks name="Pacific Biosciences" link="https://www.pacb.com" />
                    <DownloadLinks name="Ion Torrent" link="https://www.lifetechnologies.com/iontorrent" />
                </div>
            </div><br/>
            <li className="content_description">Comparison of the next-generation sequencing (NGS) Instruments.</li>
            <img className="content_img" src={img01} alt="error" />
            <ContentLink link="https://genohub.com/ngs-instrument-guide"/>
            <div className="content_buttons_div">
                <Link to="/Manual"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap02"><button className="content_button">Next</button></Link>
            </div>
        </div> 
    );
}

export default Gaap01;